import { useTopic } from 'hooks/useTopic';
import React, { FC, Fragment } from 'react';
import { Answer, Task } from 'types/elearning';
import { Question } from '..';

interface IProps {
    task: Task;
    isChecked: boolean;
    correctAnswer: Answer['correct_answer'];
    isQuiz: boolean;
}

export const QuestionsMultiple: FC<IProps> = ({
    task,
    isChecked,
    correctAnswer,
    isQuiz,
}) => {
    const { checkedAnswers, handleSetCheckedAnswersMultiple } = useTopic();
    
    return (
        <>
            {task?.content &&
                Object?.entries?.(task?.content)?.map?.(
                    ([questionId, question], id) => (
                        <Fragment key={questionId}>
                            <Question
                                questionNumber={id + 1}
                                title={question?.scenarioText ? question?.scenarioText : question?.question}
                                answers={question?.answers}
                                checkedAnswers={checkedAnswers?.[questionId]}
                                correctAnswers={correctAnswer?.[questionId]}
                                isChecked={isChecked}
                                description={question?.scenarioText ? question?.question : undefined}
                                setAnswers={(newAnswerId) =>
                                    handleSetCheckedAnswersMultiple(
                                        questionId,
                                        newAnswerId
                                    )
                                }
                                isQuiz={isQuiz}
                            />
                        </Fragment>
                    )
                )}
        </>
    );
};
